enum ApplicationRoles {
  SSTMANAGER = "Moderator.Sst",
  STOREMANAGER = "Moderator.Magasin",
}

export default ApplicationRoles;
